import Vue from "vue";
import moment from "moment";

Vue.filter("date", value => {
  let date = "";
  const format = "L";
  if (value) {
    if (typeof value === "string" && value.indexOf("/") > -1) {
      date = moment(value, "YYYY/MM/DD", true).format(format);
    }
    date = moment(value).format(format);
  }

  return date;
});

Vue.filter("longDate", value => {
  let date = "";
  const format = "ddd MMM. DD, YYYY";
  if (value) {
    if (typeof value === "string" && value.indexOf("/") > -1) {
      date = moment(value, "YYYY/MM/DD", true).format(format);
    }
    date = moment(value).format(format);
  }

  return date;
});

Vue.filter("datetime", value => moment(value).format("lll"));

Vue.filter("time", value => {
  if (value) {
    let d = "";
    if (value.indexOf("-") > -1) {
      d = moment(value);
    } else {
      d = moment(value, "HH:mm:ss");
    }
    return d.format("hh:mm A");
  }
  return "";
});
